import { EntityMetaProperty } from '@qtek/shared/models';
import { filter, Observable, of } from 'rxjs';
import { PsGroupByComponent } from '../components';
import { qtGroupByMeta } from '../utils';
import {
  PIPE_ORDER,
  QtDataSourceContext,
  QtDataTransformAdapter,
} from './qt-control-adapter';

export class GroupByMetaAdapter<T>
  implements QtDataTransformAdapter<T, EntityMetaProperty | null>
{
  readonly key = 'groupBy';
  readonly pipeOrder = PIPE_ORDER.GROUP_BY;

  private _suppress = false;
  private _ctx: QtDataSourceContext | null = null;

  readonly valueChanges$: Observable<EntityMetaProperty | null> =
    this.component.selectGroupBy.pipe(filter(() => !this._suppress));

  constructor(private component: PsGroupByComponent) {}

  setContext(ctx: QtDataSourceContext<any>): void {
    this._ctx = ctx;
  }

  get operator() {
    return qtGroupByMeta<T>(
      this.component,
      (this._ctx?.valueAccessorFn ?? ((): unknown => undefined)) as any,
      this._ctx?.groupingColumns$ ?? of([])
    );
  }

  applyValue(value: EntityMetaProperty | null): void {
    this._suppress = true;
    // closePopover=false: re-apply must not close any open popover (SD-2374).
    this.component.selectGroup(value ?? null, false);
    this._suppress = false;
  }

  getValue(): EntityMetaProperty | null {
    return this.component.groupByMeta;
  }
}
